<template>
  <div class="register-container">
    <h1>{{ $t('userRegistration') }}</h1>
    <form @submit.prevent="submitForm">
      <!-- Seção 1: Dados Pessoais -->
      <div class="form-section">
        <h3>{{ $t('select_nationality') }}</h3>
        <!-- Opções de nacionalidade -->
        <div class="nationality-selector-options">
          <!-- Opção Paraguai (estrangeiro = 0) -->
          <div class="nationality-selector-option" :class="{ 'selected': form.estrangeiro === '0' }">
            <label>
              <input type="radio" v-model="form.estrangeiro" value="0" />
              <img src="@/assets/images/bandeira-paraguai.webp" alt="Bandeira do Paraguai"
                class="nationality-flag-icon" />
              <span class="option-text">
                {{ $t('buy_online_receive_home_or_pickup') }} -
                {{ $t('payment_options') }}: {{ $t('pagopar') }}, {{ $t('pago_qr') }}, {{ $t('bank_transfer') }},
                {{ $t('credit_or_debit_card') }}, {{ $t('ueno_bank') }}, {{ $t('bocas_de_pago') }}
              </span>
            </label>
          </div>

          <!-- Opção Brasil (estrangeiro = 1) -->
          <div class="nationality-selector-option" :class="{ 'selected': form.estrangeiro === '1' }">
            <label>
              <input type="radio" v-model="form.estrangeiro" value="1" />
              <img src="@/assets/images/bandeira-brasil.webp" alt="Bandeira do Brasil" class="nationality-flag-icon" />
              <span class="option-text">
                {{ $t('buy_online_pickup_store') }} -
                {{ $t('payment_options') }}: {{ $t('voucher_pay') }}, {{ $t('pix') }}, {{
                  $t('card_up_to_10_installments') }}
              </span>
            </label>
          </div>
        </div>
        <div class="nationality-selector-wrapper">
          <p v-if="v$.form.estrangeiro.$error" class="nationality-error-message">
            {{ $t('nationality_required') }}
          </p>
        </div>
        <div class="form-group-container">

          <h2>{{ $t('personalData.title') }}</h2>
          <ContainerComponent :validator="v$.form.nome" class="input-wrapper">
            <input type="text" id="nome" v-model="form.nome" placeholder=" " @blur="v$.form.nome.$touch" />
            <label for="nome">{{ $t('personalData.name') }}</label>
          </ContainerComponent>

          <ContainerComponent :validator="v$.form.sobrenome" class="input-wrapper">
            <input type="text" id="sobrenome" v-model="form.sobrenome" placeholder=" "
              @blur="v$.form.sobrenome.$touch" />
            <label for="sobrenome">{{ $t('personalData.surname') }}</label>
          </ContainerComponent>



          <ContainerComponent :validator="v$.form.telefone" class="input-wrapper">
            <input type="tel" id="telefone" v-model="form.telefone" placeholder=" " @blur="v$.form.telefone.$touch"
              v-mask="isForeign ? telefoneMask.brasil : telefoneMask.paraguai" />
            <label for="telefone">{{ $t('phone') }}</label>
          </ContainerComponent>

          <ContainerComponent :validator="v$.form.email" class="input-wrapper">
            <input type="email" id="email" v-model="form.email" placeholder=" "
              @blur="checkEmail(); v$.form.email.$touch" />
            <label for="email">{{ $t('email') }}</label>
            <p v-if="emailError" class="error-message">{{ emailError }}</p>
          </ContainerComponent>

          <ContainerComponent :validator="v$.form.email_confirmation" class="input-wrapper">
            <input type="text" id="email_confirmation" v-model="form.email_confirmation" placeholder=" "
              @blur="v$.form.email_confirmation.$touch" />
            <label for="email_confirmation">{{ $t('emailConfirmation') }}</label>
          </ContainerComponent>

          <div class="input-group">

            <ContainerComponent :validator="v$.form.password" class="input-wrapper" style="width:48%">
              <input type="password" id="password" v-model="form.password" placeholder=" "
                @blur="v$.form.password.$touch" />
              <label for="password">
                <i class="fas fa-lock"></i> {{ $t('password') }}
              </label>
            </ContainerComponent>

            <ContainerComponent :validator="v$.form.password_confirmation" class="input-wrapper" style="width:48%">
              <input type="password" id="password_confirmation" v-model="form.password_confirmation" placeholder=" "
                @blur="v$.form.password_confirmation.$touch" />
              <label for="password_confirmation">
                <i class="fas fa-lock"></i> {{ $t('passwordConfirmation') }}
              </label>
            </ContainerComponent>
          </div>
        </div>
      </div>

      <!-- Seção 2: Documentação -->
      <div class="form-section">
        <h2>{{ $t('documentation.title') }}</h2>

        <ContainerComponent :validator="v$.form.identidade" class="input-wrapper">
          <input type="text" id="identidade" v-model="form.identidade" placeholder=" "
            @blur="v$.form.identidade.$touch" />
          <label for="identidade">{{ $t('registration.identityNumber') }}</label>
        </ContainerComponent>

        <h2 v-if="!isForeign">{{ $t('documentation.faturaRuc') }}: (Opcional)</h2>
        <div class="form-group-container">

          <ContainerComponent :validator="v$.form.documento" class="input-wrapper">
            <!-- Input para o número do documento -->
            <input type="text" id="documento" v-model="form.documento" placeholder=" "
              v-mask="isForeign ? documentosMask.cpf : documentosMask.ruc" @blur="v$.form.documento.$touch" />
            <label for="documento"> {{ isForeign ? 'CPF' : 'RUC' }}</label>
          </ContainerComponent>

          <ContainerComponent v-if="!isForeign" :validator="v$.form.razao_social" class="input-wrapper">
            <input v-model="form.razao_social" type="text" placeholder=" " class="form-control">
            <label for="razao_social">{{ $t('razaoSocial') }}</label>
          </ContainerComponent>




          <!-- <div class="input-wrapper" v-if="form.estrangeiro === '1'">
            <input type="text" id="identidade_complemento" v-model="form.identidade_complemento" placeholder=" "
              @blur="v$.form.identidade_complemento.$touch" />
            <label for="identidade_complemento">{{ $t('registration.issuingAgency') }}</label>
          </div> -->
          <h2>{{ $t('rgImages') }}:</h2>
          <div class="image-upload-container">
            <!-- Campo de upload da frente -->
            <div class="image-upload-wrapper">
              <label for="frente" class="file-upload-label">
                <div v-if="!frentePreview" class="upload-icon">
                  <i class="fas fa-id-card document-icon"></i>
                  <div class="upload-text">
                    <span>{{ $t('registration.frontImage') }}</span>
                  </div>
                </div>
                <div v-else class="image-preview">
                  <img :src="frentePreview" alt="Preview da frente" />
                </div>
                <input type="file" id="frente" @change="uploadFile('frente', $event)" />
              </label>
              <!-- Exibe o erro específico para o campo "frente" -->

            </div>


            <!-- Campo de upload do verso -->
            <div class="image-upload-wrapper">
              <label for="verso" class="file-upload-label">
                <div v-if="!versoPreview" class="upload-icon">
                  <i class="fas fa-id-card document-icon"></i>
                  <div class="upload-text">
                    <span>{{ $t('registration.backImage') }}</span>
                  </div>
                </div>
                <div v-else class="image-preview">
                  <img :src="versoPreview" alt="Preview do verso" />
                </div>
                <input type="file" id="verso" @change="uploadFile('verso', $event)" />
              </label>
              <!-- Exibe o erro específico para o campo "verso" -->

            </div>

          </div>
          <p v-if="frenteError" class="error-message">{{ frenteError }}</p>
          <p v-if="versoError" class="error-message">{{ versoError }}</p>
        </div>
      </div>

      <!-- Seção 3: Endereço -->
      <div class="form-section">
        <h2>{{ $t('address.title') }}</h2>
        <div class="form-group-container">
          <div v-if="!isForeign" class="input-wrapper">
            <span style="font-size: 1.5em;">
              {{ form.pais || 'Paraguay' }}
            </span>
          </div>

          <ContainerComponent v-if="isForeign" :validator="v$.form.cep" class="input-wrapper">
            <input type="text" id="cep" v-model="form.cep" placeholder=" " @blur="fetchAddress"
              v-mask="isForeign ? codigoPostalMask.brasil : codigoPostalMask.paraguai" />
            <label for="cep">{{ $t('cep') }}</label>
            <div v-if="isLoadingCep" class="loading-icon">
              <i class="fas fa-spinner fa-spin"></i>
            </div>
          </ContainerComponent>

          <div v-if="isForeign && showStateCitySelects">
            <ContainerComponent :validator="v$.selectedStateBr" class="input-wrapper">
              <select id="estadoBr" v-model="selectedStateBr" @change="updateCitiesBr"
                @blur="v$.selectedStateBr.$touch">
                <option disabled value="">{{ $t('escolha_estado') }}</option>
                <option v-for="estado in estados_br" :key="estado.estado_id" :value="estado.estado_id">
                  {{ estado.estado_nome }}
                </option>
              </select>
              <label for="estadoBr">{{ $t('estado') }}</label>
            </ContainerComponent>

            <ContainerComponent :validator="v$.selectedCityBr" class="input-wrapper">
              <select id="cidadeBr" v-model="form.cidade_id" :disabled="!selectedStateBr"
                @blur="v$.selectedCityBr.$touch">
                <option disabled value="">{{ $t('escolha_cidade') }}</option>
                <option v-for="cidade in citiesBr" :key="cidade.cidade_id" :value="cidade.cidade_id">
                  {{ cidade.nome_cidade }}
                </option>
              </select>
              <label for="cidadeBr">{{ $t('cidade') }}</label>
            </ContainerComponent>
          </div>

          <div v-else>
            <ContainerComponent v-if="isForeign" :validator="v$.form.estado" class="input-wrapper">
              <input type="text" id="estado" v-model="form.estado" placeholder=" " @blur="v$.form.estado.$touch"
                disabled />
              <label for="estado">{{ $t('estado') }}</label>
              <p v-if="v$.form.estado.$error" class="error-message">
                {{ $t('estadoRequired') }}
              </p>
            </ContainerComponent>

            <ContainerComponent v-if="isForeign" :validator="v$.form.cidade" class="input-wrapper">
              <input type="text" id="cidade" v-model="form.cidade" placeholder=" " @blur="v$.form.cidade.$touch"
                disabled />
              <label for="cidade">{{ $t('cidade') }}</label>
              <p v-if="v$.form.cidade.$error" class="error-message">
                {{ $t('cidadeRequired') }}
              </p>
            </ContainerComponent>
          </div>


          <ContainerComponent v-if="!isForeign" :validator="v$.selectedState" class="input-wrapper">
            <select id="estado" v-model="selectedState" @change="updateCities" @blur="v$.selectedState.$touch">
              <option disabled value="">{{ $t('escolha_estado') }}</option>
              <option v-for="estado in estados" :key="estado.estado_id" :value="estado.estado_id">
                {{ estado.estado_nome }}
              </option>
            </select>
          </ContainerComponent>

          <ContainerComponent v-if="!isForeign" :validator="v$.selectedCity" class="input-wrapper">
            <select id="cidade" v-model="selectedCity" :disabled="!selectedState" @blur="v$.selectedCity.$touch">
              <option disabled value="">{{ $t('escolha_cidade') }}</option>
              <option v-for="cidade in cities" :key="cidade.cidade_id" :value="cidade.cidade_id">
                {{ cidade.nome_cidade }}
              </option>
            </select>
          </ContainerComponent>

          <ContainerComponent :validator="v$.form.logradouro" class="input-wrapper">
            <input type="text" id="logradouro" v-model="form.logradouro" placeholder=" "
              @blur="v$.form.logradouro.$touch" />
            <label for="logradouro">{{ $t('logradouro') }}</label>
          </ContainerComponent>

          <ContainerComponent v-if="!isForeign" :validator="v$.form.como_chegar" class="input-wrapper">
            <textarea v-model="form.como_chegar" placeholder=" " class="form-control">
            </textarea>
            <label for="como_chegar">{{ $t('como_chegar') }}</label>
          </ContainerComponent>


          <!-- <ContainerComponent v-if="!isForeign" :validator="v$.form.numero" class="input-wrapper" >
            <input type="text" id="numero" v-model="form.numero" placeholder=" " @blur="v$.form.numero.$touch" />
            <label for="numero">{{ $t('Numero') }}</label>
          </ContainerComponent>

          <ContainerComponent v-if="!isForeign" :validator="v$.form.bairro" class="input-wrapper" >
            <input type="text" id="bairro" v-model="form.bairro" placeholder=" " @blur="v$.form.bairro.$touch" />
            <label for="bairro">{{ $t('bairro') }}</label>
          </ContainerComponent> -->

        </div>
        <div v-if="errors && Object.keys(errors).length > 0" class="error-section">
          <h2> {{ $t('formErrors') }}</h2>
          <ul>
            <li v-for="(errorList, field) in errors" :key="field">
              <strong> {{ field }}:</strong>
              <span v-for="(error, index) in errorList" :key="index">{{ error }}</span>
            </li>
          </ul>
        </div>
      </div>
      <p v-if="isForeign">{{ $t('registration.address_rg_notice') }}</p>
      <!-- Botão de Envio -->
      <div class="form-navigation">
        <button type="submit" :disabled="isSubmitting">
          {{ $t('register') }}
          <LoaderSpinner :isLoading="isSubmitting"> </LoaderSpinner>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, email, minLength, sameAs, helpers, maxLength } from '@vuelidate/validators';
import axios from 'axios';
import { estados_py, estados_br } from '../components/Cidades';
import { documentosMask, telefoneMask, codigoPostalMask } from '../components/Mascaras';
import ContainerComponent from '../components/ContainerComponent';
import LoaderSpinner from '../components/LoaderSpinner';
import { mask } from 'vue-the-mask'

export default {
  name: 'ViewCadastroUsuario',
  components: {
    ContainerComponent,
    LoaderSpinner
  },
  directives: { mask },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      form: {
        nome: '',
        sobrenome: '',
        email: '',
        email_confirmation: '',
        estrangeiro: 0,
        telefone: '',
        password: '',
        password_confirmation: '',
        cep: '',
        logradouro: '',
        numero: '',
        bairro: '',
        documento_tipo: 'RUC',
        documento: '',
        identidade: '',
        pais_id: null,
        pais: '',
        frente: null,
        verso: null,
        como_chegar: '',
        razao_social: ''
      },
      estados: estados_py,
      estados_br: estados_br,
      cities: [],
      citiesBr: [],
      selectedState: "",
      selectedCity: "",
      selectedStateBr: "",
      selectedCityBr: "",
      showStateCitySelects: false,
      emailError: '',
      frentePreview: null,
      versoPreview: null,
      errors: {},
      cepError: '',
      isLoadingCep: false,
      frenteError: '',
      versoError: '',
      documentosMask: documentosMask,
      telefoneMask: telefoneMask,
      codigoPostalMask: codigoPostalMask
    };
  },
  validations() {
    return {
      form: {
        nome: { required, maxLength: maxLength(200) },
        sobrenome: { required, maxLength: maxLength(200) },
        razao_social: { maxLength: maxLength(200) },
        email: {
          required: helpers.withMessage('required', required),
          email: helpers.withMessage('email', email),
          maxLength: maxLength(200)
        },
        email_confirmation: {
          required,
          email,
          sameAsEmail: helpers.withMessage(
            'Os e-mails devem ser iguais',
            (value) => value?.toLowerCase() === (this.form.email?.toLowerCase() || '')
          )
        },

        estrangeiro: { required },
        telefone: { required, maxLength: maxLength(20) },
        password: {
          required: helpers.withMessage('required', required),
          minLength: helpers.withMessage('minLength', minLength(8)),
          maxLength: maxLength(20),
          notPassword: helpers.withMessage('notPassword', (value) => value !== 'password'),
        },
        password_confirmation: { required, sameAsPassword: sameAs(this.form.password) },
        cep: { required: this.form.estrangeiro === '1', maxLength: maxLength(10) },
        logradouro: { required, maxLength: maxLength(200) },
        //numero: { required, maxLength: maxLength(10) },
        //bairro: { required, maxLength: maxLength(60) },
        pais: { required: this.isForeign },
        cidade: { required: this.isForeign },
        estado: { required: this.isForeign },
        documento_tipo: { required, maxLength: maxLength(20) },
        documento: { required: !this.isForeign, maxLength: maxLength(20) },
        identidade: { required, maxLength: maxLength(20) },
        identidade_complemento: { required: this.form.estrangeiro === '1', maxLength: maxLength(10) },
        frente: { required },
        verso: { required },
      },
      selectedState: { required: !this.isForeign },
      selectedCity: { required: !this.isForeign },
      selectedStateBr: { required: this.isForeign && this.showStateCitySelects },
      selectedCityBr: { required: this.isForeign && this.showStateCitySelects },

    };
  },
  computed: {
    isForeign() {
      return this.form.estrangeiro === '1';
    },
    pais_id() {
      return this.form.estrangeiro === '0' ? 2 : null;
    },
  },
  methods: {
    async checkEmail() {
      this.emailError = '';

      if (!this.form.email || this.v$.form.email.$error) {
        return false;
      }

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URI}/ecom/cliente/cadastrar/check-email`,
          { email: this.form.email }
        );

        if (response.status === 200) {
          return true;
        }

        if (response.data.errors?.email) {
          this.emailError = response.data.errors.email[0];
          return false;
        }

        console.log("Resposta inesperada da API:", response.data);
        return false;
      } catch (error) {
        if (error.response?.data?.errors?.email) {
          this.emailError = error.response.data.errors.email[0];
        } else {
          this.emailError = this.$t('emailCheckError');
        }
        console.error("Erro ao verificar e-mail:", error);
        return false;
      }
    },
    async fetchAddress() {
      if (this.form.estrangeiro === '1' && this.form.cep) {
        this.isLoadingCep = true;
        this.cepError = '';

        try {
          let cep = this.form.cep.replace(/\D/g, '');
          const viaCepResponse = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
          const viaCepData = viaCepResponse.data;

          if (viaCepData.erro) {
            throw new Error('CEP não encontrado');
          }

          this.form.logradouro = viaCepData.logradouro;
          this.form.bairro = viaCepData.bairro;
          this.form.cidade = viaCepData.localidade;
          this.form.estado = viaCepData.uf;

          const codigoIbge = viaCepData.ibge;

          const cidadeResponse = await axios.post(`${process.env.VUE_APP_API_URI}/ecom/endereco/cidade-por-codigo`, {
            pais_id: 1,
            codigo: codigoIbge
          });

          if (cidadeResponse.data && cidadeResponse.data.id) {
            this.form.cidade_id = cidadeResponse.data.id;
            this.form.pais_id = cidadeResponse.data.estado.pais_id;
          } else {
            throw new Error('Cidade não encontrada');
          }

          this.showStateCitySelects = false;
        } catch (error) {
          console.error('Erro ao buscar endereço:', error);
          this.showStateCitySelects = true;
          this.cepError = 'CEP não encontrado. Selecione o estado e a cidade manualmente.';
        } finally {
          this.isLoadingCep = false;
        }
      }
    },

    updateCities() {
      this.cities = [];
      const estadoSelecionado = this.estados.find(
        (estado) => estado.estado_id === parseInt(this.selectedState, 10)
      );

      if (estadoSelecionado) {
        this.cities = estadoSelecionado.cidades;
      }
    },
    updateCitiesBr() {
      this.citiesBr = [];
      const estadoSelecionado = this.estados_br.find(
        (estado) => estado.estado_id === parseInt(this.selectedStateBr, 10)
      );

      if (estadoSelecionado) {
        this.citiesBr = estadoSelecionado.cidades;
      }
    },
    uploadFile(field, event) {
      const file = event.target.files[0];
      if (!file) return;

      this[`${field}Error`] = '';

      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        this[`${field}Error`] = this.$t('fileSizeError');
        return;
      }

      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        this[`${field}Error`] = this.$t('fileTypeError');
        return;
      }

      this.form[field] = file;

      if (this.isImage(file)) {
        const reader = new FileReader();
        reader.onload = () => {
          if (field === 'frente') {
            this.frentePreview = reader.result;
          } else if (field === 'verso') {
            this.versoPreview = reader.result;
          }
        };
        reader.readAsDataURL(file);
      }
    },
    isImage(file) {
      return file && file.type.startsWith('image/');
    },
    isImage(file) {
      return file && file.type.startsWith('image/');
    },
    async submitForm() {
      this.isSubmitting = true;
      this.statusMessage = "";
      this.errors = {};

      this.v$.form.$touch();

      if (this.v$.form.$invalid) {
        this.errors = {
          'Campos': ' ' + this.$t('formMessage')
        }
        this.isSubmitting = false;

        return;
      }

      try {
        const formData = new FormData();
        formData.append('pais_id', this.form.pais_id);
        formData.append('pais', this.form.pais);
        Object.keys(this.form).forEach((key) => {
          if (this.form[key] !== null && this.form[key] !== undefined) {
            if (key === 'frente' || key === 'verso') {
              if (this.form[key]) {
                formData.append(key, this.form[key]);
              }
            } else {
              formData.append(key, this.form[key]);
            }
          }
        });

        if (this.selectedState) {
          formData.append('estado_id', this.selectedState);
        }
        if (this.selectedCity) {
          formData.append('cidade_id', this.selectedCity);
        }

        const registerResponse = await axios.post(
          `${process.env.VUE_APP_API_URI}/ecom/cliente/cadastrar`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (registerResponse.status !== 200) {
          throw new Error(resolveError(registerResponse));
        }

        this.statusMessage = this.$t('registerSuccess');
        this.isSuccess = true;

        const loginResponse = await axios.post(
          `${process.env.VUE_APP_API_URI}/ecom/login`,
          {
            email: this.form.email,
            password: this.form.password,
          }
        );

        if (loginResponse.status !== 200) {
          throw new Error(resolveError(loginResponse));
        }

        const loginData = loginResponse.data;
        this.$store.dispatch('auth/saveAuth', {
          token: loginData.token,
          user: loginData.user,
        });

        const redirectRoute = this.$route.query.redirect;
        if (redirectRoute === '/checkout') {
          this.$router.push(redirectRoute);
        } else {
          this.$router.push('/perfil');
        }
      } catch (error) {
        this.isSuccess = false;
        this.errors = {};

        if (error.response) {
          const responseData = error.response.data;

          if (responseData.errors) {
            this.errors = responseData.errors;
          }

          if (!this.statusMessage) {
            this.statusMessage = responseData.message || this.$t('errorMessage');
          }
        } else {
          this.statusMessage = this.$t('errorMessage');
        }

        console.error('Erro no cadastro/login:', error.response ? error.response.data : error.message);
      } finally {
        this.isSubmitting = false;
      }
    }
  },

  watch: {
    'form.estrangeiro': function (newVal) {
      if (newVal === '0') {
        this.form.documento_tipo = 'RUC';
      } else {
        this.form.documento_tipo = 'CPF';
      }

      if (newVal === '0') {
        this.form.pais_id = 2;
        this.form.pais = 'Paraguay';
        this.$i18n.locale = 'es-PY';
      } else if (newVal === '1') {
        this.form.pais_id = 1;
        this.form.pais = 'Brasil';
        this.$i18n.locale = 'pt-BR';
      } else {
        this.form.pais_id = null;
        this.form.pais = '';
      }
    },
  },
  mounted() {
    if (this.$i18n.locale === 'pt-BR') {
      this.form.estrangeiro = '1'; // Brasil
    } else {
      this.form.estrangeiro = '0'; // Paraguai
    }
  }

};
</script>

<style scoped>
.loading-icon {
  position: absolute;
  right: 10px;
  /* Posiciona o ícone à direita do campo */
  top: 50%;
  transform: translateY(-50%);
  /* Centraliza verticalmente */
  color: #007bff;
  /* Cor do ícone */
}

.input-wrapper {
  position: relative;
  /* Permite posicionar o ícone de loading dentro do campo */
}

.register-container {
  max-width: 700px;
  margin: 50px auto;
  padding: 40px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  font-family: 'Roboto', sans-serif;
}

h1 {
  text-align: center;
  font-size: 32px;
  color: #333;
  font-weight: 700;
  margin-bottom: 20px;
  color: #E23B33
}

h2 {
  margin-bottom: 20px;
  color: #E23B33;
  font-weight: 500;
  font-size: 22px;
}

h3 {
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 500;
}

.progress-bar {
  background: #e0e0e0;
  height: 10px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #E23B33, #c59041);
  transition: width 0.4s ease;
}

.form-group-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 5px;
}

.input-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
}

.input-wrapper input,
.input-wrapper select {
  padding: 14px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.section-title {
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 20px;
}

.input-wrapper input:focus,
.input-wrapper select:focus {
  border-color: #E23B33;
  box-shadow: 0 0 6px rgba(108, 99, 255, 0.3);
}

.input-wrapper label {
  position: absolute;
  top: 50%;
  left: 16px;
  font-size: 16px;
  color: #888;
  pointer-events: none;
  transform: translateY(-50%);
  transition: 0.3s ease;
}

.input-wrapper2 label {
  position: absolute;
  top: 10px;
  left: 16px;
  font-size: 16px;
  color: #888;
  pointer-events: none;
  transform: translateY(-50%);
  transition: 0.3s ease;
}

.input-wrapper input:focus+label,
.input-wrapper input:not(:placeholder-shown)+label,
.input-wrapper select:focus+label,
.input-wrapper select:not([value=""]):valid+label {
  top: 0;
  font-size: 14px;
  color: #666666;
  transform: translateY(-20px);
}

.input-wrapper input.error,
.input-wrapper select.error {
  border-color: #dc3545;
  background-color: #f8d7da;
}

.input-wrapper input.error:focus,
.input-wrapper select.error:focus {
  box-shadow: 0 0 6px rgba(220, 53, 69, 0.5);
}

.input-group {
  display: flex;
  gap: 10px;
}

.form-navigation {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  gap: 15px;
}

button {
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 12px;
  background-color: #E23B33;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #c59041;
}

button:active {
  transform: translateY(2px);
}

button[disabled] {
  background-color: #b0b0b0;
  cursor: not-allowed;
}

.error-message {
  color: #dc3545;
  font-size: 0.9rem;
  margin-top: 0.3rem;
}

.cep-error-message {
  color: #b68585;
  font-size: 0.9rem;
  margin-top: 0.3rem;
}

@media (max-width: 768px) {
  .form-group-container {
    grid-template-columns: 1fr;
  }
}

.input-wrapper {
  margin-bottom: 20px;
}

.file-upload-label {
  font-weight: bold;
  display: block;
  margin-top: -20px
}

.image-preview {
  margin-top: 10px;
}

.image-preview img {
  max-width: 100%;
  max-height: 150px;
  border: 1px solid #ccc;
  border-radius: 4px;
  object-fit: contain;

}

.nationality-selector-wrapper {
  max-width: 800px;
  margin: 0 auto;
  margin-bottom: 20px
}

.nationality-selector-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.nationality-selector-option {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.nationality-selector-option.selected {
  background-color: #f0f0f0;
  border-color: #E23B33;
}

.nationality-selector-option label {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
}

.nationality-flag-icon {
  width: 24px;
  height: 16px;
  margin-right: 10px;
  margin-left: 5px;
  flex-shrink: 0;
}

.option-text {
  flex: 1;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.2;
  font-size: 0.9em;
  color: #666;
  max-width: 600px;
}

.nationality-error-message {
  color: red;
  font-size: 0.875em;
  margin-top: 10px;
}

@media (max-width: 600px) {
  .option-text {
    white-space: normal;
  }
}

.image-upload-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.image-upload-wrapper {
  flex: 1;
  position: relative;
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-upload-wrapper:hover {
  border-color: #E23B33;
}

.file-upload-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.upload-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.document-icon {
  font-size: 48px;
  color: #E23B33;
}

.upload-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.small-upload-icon {
  font-size: 18px;
  color: #666;
}

.upload-text span {
  font-size: 14px;
  color: #666;
}

.image-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-preview img {
  max-width: 100%;
  max-height: 150px;
  border-radius: 8px;
  object-fit: cover;
}

input[type="file"] {
  display: none;
}

.input-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
}

.input-wrapper textarea {
  padding: 14px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
  box-sizing: border-box;
  resize: vertical;
  min-height: 120px;
}

.input-wrapper textarea:focus {
  border-color: #E23B33;
  box-shadow: 0 0 6px rgba(108, 99, 255, 0.3);
}



.input-wrapper textarea:focus+label,
.input-wrapper textarea:not(:placeholder-shown)+label {
  top: -8px;
  font-size: 14px;
  color: #464646;
}

.input-wrapper textarea.error {
  border-color: #dc3545;
  background-color: #f8d7da;
}

.input-wrapper textarea.error:focus {
  box-shadow: 0 0 6px rgba(220, 53, 69, 0.5);
}

.input-wrapper textarea:focus+label,
.input-wrapper textarea:not(:placeholder-shown)+label {
  top: -12px;
  /* Movendo um pouco mais para cima */
  font-size: 14px;
  color: #535353;
}

.error-section {
  margin-top: 20px;
  padding: 15px;
  background-color: #ffebee;
  border: 1px solid #ffcdd2;
  border-radius: 4px;
  color: #c62828;
}

.error-section h2 {
  margin-bottom: 10px;
  font-size: 1.2em;
}

.error-section ul {
  list-style-type: none;
  padding: 0;
}

.error-section li {
  margin-bottom: 5px;
}

.error-section strong {
  font-weight: bold;
}
</style>